<template>
  <div class="table -payout">
    <div class="t-tabs" :class="{ '-collumn': collumn }">
      <div :class="{ '-open': addDayOpen }" class="-tab -add">
        <i @click="addDayToggle" id="popover-calendar" class="fas fa-plus"></i>
        <b-popover
          target="popover-calendar"
          placement="bottomright"
          custom-class="popover-calendar"
        >
          <v-date-picker
            :mode="'single'"
            color="gray"
            is-inline
            :show-day-popover="false"
            v-model="selectedDate"
          >
          </v-date-picker>
        </b-popover>
      </div>
      <div
        :key="day"
        v-for="day in sort(payout_days)"
        class="-tab"
        :class="{ '-active': currentDay(day) }"
        @click="selectDate(day)"
      >
        <span v-if="day">{{ $moment(day).format("DD MMM") }}</span>
      </div>
    </div>
    <div class="t-body">
      <h3>
        Выдача зарплаты
        <button
          style="margin-left: 5px"
          @click="addUserPopover"
          id="popover-add-payout"
          v-if="usersNotInList.length"
        >
          добавить
        </button>
        <b-popover
          target="popover-add-payout"
          placement="bottomleft"
          trigger="manual"
          custom-class="popover-add"
          @hide="closeAddUserPopover"
        >
          <ul>
            <li
              @click="toggleUserInList(u)"
              v-for="u in usersNotInList"
              :key="u._id"
            >
              <p>{{ u.first_name }} {{ u.last_name }}</p>
              <span v-if="userInList(u)">
                <i class="fas fa-check" aria-hidden="true"></i>
              </span>
            </li>
          </ul>
        </b-popover>
        <button v-if="payout.length" @click="removeDate">удалить</button>
      </h3>
      <div v-if="noDataHide" class="t-head">
        <div class="-row">
          <div class="-cell">Имя</div>
          <div class="-cell">Нал</div>
          <div class="-cell">Оф зп</div>
          <div class="-cell">НДФЛ</div>
          <div class="-cell"></div>
        </div>
      </div>
      <micro-loading v-if="loading" />
      <div class="t-data" v-if="noDataHide">
        <div :key="p.id" v-for="p in payout" class="-row">
          <div class="-cell">
            <p>{{ userName(p.owner) }}</p>
          </div>
          <div class="-cell">
            <span class="pseudo-input">{{
              $formatNumber(p.cashout || 0)
            }}</span>
            <input
              @input="$onlyNumber"
              :data-date="p.date"
              data-name="cashout"
              :data-owner="p.owner"
              @change="updateFinance"
              v-model="p.cashout"
              type="tel"
              @click="selectRange"
              :class="{ '-opacity': p.cashout }"
            />
          </div>
          <div class="-cell">
            <span class="pseudo-input">{{
              $formatNumber(p.cardout || 0)
            }}</span>
            <input
              @input="$onlyNumber"
              :data-date="p.date"
              data-name="cardout"
              :data-owner="p.owner"
              @change="updateFinance"
              v-model="p.cardout"
              type="tel"
              @click="selectRange"
              :class="{ '-opacity': p.cardout }"
            />
          </div>
          <div class="-cell">
            <span class="pseudo-input">{{ $formatNumber(p.payout || 0) }}</span>
            <input
              @input="$onlyNumber"
              :data-date="p.date"
              data-name="payout"
              :data-owner="p.owner"
              @change="updateFinance"
              v-model="p.payout"
              type="tel"
              @click="selectRange"
              :class="{ '-opacity': p.payout }"
            />
          </div>
          <div @click="removeUserFromList(p)" class="-cell -show-on-hover">
            <span>скрыть</span>
          </div>
        </div>
      </div>
      <div class="t-sum" v-if="noDataHide">
        <div class="-row">
          <div class="-cell"></div>
          <div class="-cell">{{ $formatNumber(counter("cashout") || 0) }}</div>
          <div class="-cell">{{ $formatNumber(counter("cardout") || 0) }}</div>
          <div class="-cell">{{ $formatNumber(counter("payout") || 0) }}</div>
        </div>
      </div>
      <div class="t-data" v-if="noDataShow">
        <p class="no_data">Нет данных</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      selectedDate: new Date(),
      addDayOpen: false,
      collumn: false,
      loading: true,
      currentDate: null,
      addUsers: [],
      addUserPopoverState: false
    };
  },
  computed: {
    ...mapState("finance", ["payout", "payout_days"]),
    ...mapState("app", ["users"]),
    ...mapGetters("app", ["resolveUser"]),
    ...mapGetters("finance", ["currentDay", "counter"]),
    noDataHide() {
      return !this.loading && this.payout.length;
    },
    noDataShow() {
      return !this.loading && !this.payout.length;
    },
    usersNotInList() {
      return this.users.filter(
        user => !this.payout.some(p => p.owner === user.email)
      );
    },
    userInList() {
      return user => this.addUsers.some(u => u.email === user.email);
    }
  },
  watch: {
    async selectedDate(nv) {
      const date = new Date(nv).setHours(0, 0, 0, 0);
      await this.addPayoutDate({ date: date });
      // await this.selectDate(date)
    },
    "this.$route"() {
      this.calcTabs();
    },
    payout() {
      this.calcTabs();
      try {
        this.currentDate = this.payout[0].date;
      } catch (e) {
        void e;
      }
    },
    payout_days() {
      this.calcTabs();
    }
  },
  methods: {
    ...mapActions("finance", [
      "getPayout",
      "getPayoutByDay",
      "addPayoutDate",
      "updatePayout",
      "removePayoutDate",
      "removeUserPayout",
      "addUsersPayout"
    ]),
    async refresh() {
      this.currentDate
        ? await this.getPayoutByDay({ date: parseInt(this.currentDate) })
        : await this.getPayout();
    },
    selectRange(ev) {
      if (ev.target.value === "0") ev.target.select();
    },
    removeUserFromList(p) {
      const { date, owner } = p;
      this.removeUserPayout({ date, owner });
      this.$nextTick(async () => await this.refresh());
    },
    addUserPopover() {
      this.addUserPopoverState = true;
    },
    toggleUserInList(user) {
      const index = this.addUsers.findIndex(u => u._id === user._id);
      index > -1 ? this.addUsers.splice(index, 1) : this.addUsers.push(user);
    },
    closeAddUserPopover() {
      const month = new Date(new Date(this.currentDate).setDate(1)).getTime();
      if (this.addUsers.length) {
        this.addUsersPayout({
          users: this.addUsers,
          day: this.currentDate,
          month
        });
        this.$nextTick(async () => await this.refresh());
        this.addUsers = [];
      }
      this.addUserPopoverState = false;
    },
    calcTabs() {
      // set flex collumn when tabs width > tab-scroll width
      const tabsWidth = document.querySelector(".t-tabs").offsetWidth;
      const allWidth = this.payout_days.length * 80 + 80;
      this.collumn = allWidth > tabsWidth;
      this.loading = false;
    },
    closeDayOpen() {
      this.$nextTick(() => {
        this.addDayOpen = false;
      });
    },
    addDayToggle() {
      this.addDayOpen = !this.addDayOpen;
    },
    sort(arr) {
      if (arr) return arr.slice().sort((a, b) => b - a);
    },
    userName(email) {
      try {
        const { first_name, last_name } = this.resolveUser(email);
        if (first_name && last_name) {
          if (this.$mediaQuery() === "mobile")
            return `${first_name.charAt(0)}. ${last_name}`;
          else return `${first_name} ${last_name}`;
        } else {
          return email;
        }
      } catch (e) {
        void e;
        return email;
      }
    },
    async selectDate(date) {
      this.currentDate = parseInt(date);
      await this.getPayoutByDay({ date: parseInt(date) });
    },
    updateFinance(ev) {
      const { date, owner, name } = ev.target.dataset;
      const { value } = ev.target;
      this.updatePayout({
        field: name,
        value: value ? parseInt(value.replace(/\s/g, "")) : 0,
        //[name]: value ? parseInt(value.replace(/\s/g, '')) : 0,
        date: parseInt(date),
        owner: owner
      });
    },
    removeDate() {
      const date = this.payout[0].date;
      const question = `Подтверждаете полное удаление данных о финансовых операциях за ${this.$moment(
        date
      ).format("DD MMMM")}? <br><br> Действие необратимо.`;
      this.$root
        .$confirm({
          header: "Удаление страницы",
          body: question,
          agree: "Подтверждаю",
          cancel: "Отмена"
        })
        .then(async () => {
          await this.removePayoutDate({ date });
          if (this.payout_days.length)
            this.selectDate(this.payout_days[0].date);
        })
        .catch(e => void e);
    }
  },
  async mounted() {
    await this.getPayout();
    this.$nextTick(() => {
      setTimeout(() => this.calcTabs(), 200); //fix tabs
    });

    window.onresize = () => {
      if (this.$route.name === "finance_payout") this.calcTabs();
    };
  }
};
</script>
<style>
.popover .arrow {
  display: none;
}
.popover-calendar {
  top: 300px !important;
  left: -14px !important;
  z-index: 5;
}
.popover-add {
  left: 40px !important;
}
.popover-body {
  padding: 0;
}
</style>
